// extracted by mini-css-extract-plugin
export default {"header":"MobileHeader_header__z+ijR","logoBox":"MobileHeader_logoBox__i5CkI"};